import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  // View actions
  RegisterPse: [
    'selectPeriod',
    'ddjjSusaludDoc',
    'ddjjInsuranceValidity',
    'attachedFiles',
    'isAutomated'
  ],
  // Reducer
  RegisterPseClear: null,
  RegisterPseRequest: null,
  RegisterPseSuccess: null,
  RegisterPseFailure: ['error']
});

export { Creators, Types };
